// extracted by mini-css-extract-plugin
export default {"ssoButton":"sso-button_ssoButton__rztFG"};